'use strict';

var $ = require('jquery');

var imagesLoaded = require('imagesloaded');

import {debounce, partial} from '../components/custom-lodash';

var $window = $(window);

/**
 * @description Adjust size of text on responsive reactions
 */
function adjustTextTeasers() {
    $('.module-product-description, .module-picture-text').each(function () {
        var $module = $(this);
        var $imageBox = $module.find('.description-image');
        var $image = $imageBox.find('img');
        var $textBox = $module.find('.description-text');
        var $controllsDiv = $module.find('.text-teaser-controlls');
        var $showMoreLink = $controllsDiv.find('.show-more-link');
        var imageHeight;
        var textBoxHeight;
        var threshold = 25;

        if ($image && $textBox) {
            imageHeight = $image.height();
            textBoxHeight = $textBox.prop('scrollHeight');

            // do adaption
            if (textBoxHeight > imageHeight && textBoxHeight - imageHeight > threshold) {
                $textBox.data('init-height', textBoxHeight);
                $textBox.css('overflow', 'hidden');
                $textBox.animate({height: imageHeight});
                $controllsDiv.show();
                $showMoreLink.show();
            } else if (textBoxHeight < imageHeight) {
                $textBox.css('height', 'auto');
                $controllsDiv.hide();
                $showMoreLink.hide();
            }
        }
    });
}

/**
 * @description Initialize teaser functionality for modules
 */
function initTextTeasers() {
    $('.module-product-description, .module-picture-text')
        .not('initialized')
        .each(function () {
            imagesLoaded($(this)).on(
                'done',
                function () {
                    var $module = $(this);
                    var $imageBox = $module.find('.description-image');
                    var $image = $imageBox.find('img');
                    var $textBox = $module.find('.description-text');
                    var $showMoreLink = $('<a/>', {class: 'show-more-link'}).text(Resources.SHOW_MORE);
                    // var $showLessLink = $('<a/>', {'class': 'show-less-link'}).text(Resources.SHOW_LESS);
                    var $controllsDiv = $('<div/>', {class: 'text-teaser-controlls'}).html($showMoreLink);
                    var imageHeight;
                    var textBoxHeight;
                    var threshold = 25;

                    if ($image && $textBox) {
                        imageHeight = $image.height();
                        textBoxHeight = $textBox.prop('scrollHeight');
                        // $textBox.append($showMoreLink).append($showLessLink);
                        $textBox.append($controllsDiv);

                        $showMoreLink.click(function (e) {
                            var initHeight = $textBox.data('init-height') || '120px';
                            e.preventDefault();
                            $textBox.animate({height: initHeight});
                            $controllsDiv.hide();
                        });

                        // do adaption
                        if (textBoxHeight > imageHeight && textBoxHeight - imageHeight > threshold) {
                            $textBox.data('init-height', textBoxHeight);
                            $textBox.css('overflow', 'hidden');
                            $textBox.animate({height: imageHeight});
                            $controllsDiv.show();
                            $showMoreLink.show();
                        }
                    }

                    $module.addClass('initialized');
                }.bind(this)
            );
        });
}

// Add a link in the teaser-box using as base the link in the teaser-image seted in Demandware
function clickableOnlyOnDesktop() {
    // by clicking in the teaser-box...
    $('.teaser-box').on('click', function (e) {
        var $this = $(this);
        var $target = $(e.target);
        var browserWidth = $(window).width();
        var browserWidthBreakPoint = 768;
        var $teaserImage;
        var $teaserImageLink;
        var linkImage;

        // Only for tablet and desktop screensizes
        if (!($target.is('a') || $target.parents('a').length) && browserWidth >= browserWidthBreakPoint) {
            // Only if have a link in the image
            $teaserImage = $this.siblings('.teaser-image').first();
            if ($teaserImage.children('a').length) {
                $teaserImageLink = $teaserImage.find('a.teaser-image-inner');
                if ($teaserImageLink.length) {
                    linkImage = $teaserImageLink.attr('href');
                }

                // Redirect to the link
                if (linkImage) {
                    window.location.href = linkImage;
                    e.preventDefault();
                }
            }
        }
    });
}

exports.init = function () {
    $('.teaser').each(function () {
        var height = $(this).css('height');

        if (height !== undefined) {
            $(this).data('init-height', height);
        }
    });

    $('.teaser .show-more-link').click(function (e) {
        var $teaser = $(this).closest('.teaser');
        var initHeight = $teaser.data('init-height') || '120px';
        var duration = $teaser.data('toggle-duration') || 400;
        var $teaserContent = $teaser.find('.teaser-content');
        e.preventDefault();

        if (!$teaser.hasClass('expanded')) {
            $teaserContent.animate({height: $teaserContent.find('.content-asset').height()}, duration);
            $teaser.addClass('expanded');
        } else {
            $teaserContent.animate({height: initHeight}, duration);
            $teaser.removeClass('expanded');
        }
    });

    initTextTeasers();
    clickableOnlyOnDesktop();

    $window.on('resize orientationchange', debounce(partial(adjustTextTeasers, true), 10));
};
